// Standard Jerny tooltip styling — used across all components
// pointer-events: none on the popper — a tooltip can never intercept hover
// or clicks, even when its rendered box visually overlaps a different
// clickable item underneath. MUI's default "interactive" Tooltip keeps
// itself open while the cursor is over the popper itself, not just the
// anchor — with pointer-events: none the popper can't receive that hover
// at all, so it always closes based on the anchor alone.
export const tooltipSx = {
    tooltip: {
        sx: {
            background: 'linear-gradient(180deg, #1c3f5c 0%, #13314a 100%)',
            color: '#e3edf7',
            border: '1px solid #4d7aa8',
            borderTop: '1px solid #6f9bc7',
            boxShadow: '0 1px 0 rgba(255, 255, 255, 0.08) inset, 0 4px 12px rgba(0, 0, 0, 0.6), 0 1px 3px rgba(0, 0, 0, 0.4)',
            fontSize: '11px',
            borderRadius: '4px',
            lineHeight: 1.2,
            padding: '4px 8px',
        },
    },
    popper: { style: { pointerEvents: 'none' } },
};

// Elevated variant — same tooltip skin but with higher z-index popper
// Use inside panels with z-index >= 9999 (JInspector, YourNotesSettings, etc.)
// 20000, not 10000 — JxFormBase.PINNED_OFFSET is 10000, so a pinned panel's own
// zIndex (base zIndex + 10000) could already sit AT or above a 10000 tooltip,
// pushing the tooltip behind the pinned panel (bug: CommandBarWidget pinned).
export const tooltipSxElevated = {
    ...tooltipSx,
    popper: { style: { ...tooltipSx.popper.style, zIndex: 20000 } },
};
